module.exports = __webpack_public_path__ + "static/media/intro.00ddac9a.mp3";